export default __webpack_public_path__ + "static/media/Group.3651b3f5.svg";